import { LogLevel } from "@azure/msal-browser";

/**
 * MSAL (Microsoft Authentication Library) Configuration
 * -----------------------------------------------------
 * Handles Azure Entra External ID (CIAM) authentication for the frontend SPA.
 */

export const msalConfig = {
  auth: {
    // 🔹 Your SPA (frontend) client ID
    clientId: process.env.REACT_APP_AZURE_FRONTEND_CLIENT_ID,

    // 🔹 External ID (CIAM) authority format - must include /v2.0 at the end
    authority: `https://${process.env.REACT_APP_AZURE_TENANT_DOMAIN}/${process.env.REACT_APP_AZURE_TENANT_ID}/v2.0`,

    // 🔹 Required for CIAM / multi-tenant trust
    knownAuthorities: [process.env.REACT_APP_AZURE_TENANT_DOMAIN],

    // 🔹 Redirects — must be your frontend URL (never backend)
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,

    // 🔹 Stay on the redirect URI after auth instead of navigating back to the
    // URL that started the login. The default (true) returned invite users to
    // /login?email=…, which re-armed the auto-login effect and could fire a
    // second sign-in. With false, HomeRedirect completes the login in one pass.
    navigateToLoginRequestUrl: false,
  },

  cache: {
    // localStorage survives browser redirects on mobile (sessionStorage is cleared
    // by iOS Safari / Android Chrome when navigating back from Azure CIAM redirect).
    // storeAuthStateInCookie is a fallback for iOS Safari strict privacy mode.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },

  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        const tag = "[MSAL]";
        switch (level) {
          case LogLevel.Error:
            console.error(`${tag} Error:`, message);
            break;
          case LogLevel.Warning:
            console.warn(`${tag} Warning:`, message);
            break;
          case LogLevel.Info:
            console.info(`${tag} Info:`, message);
            break;
          case LogLevel.Verbose:
            console.debug(`${tag} Verbose:`, message);
            break;
          default:
            console.log(`${tag}`, message);
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Login Request Scopes
 * -----------------------------------------------------
 * Must exactly match your backend’s exposed API scope.
 * In Azure Portal → App registrations → Backend App → Expose an API:
 *   Application ID URI = api://<backend-client-id>
 *   Scope Name         = access_as_user
 */
export const loginRequest = {
  scopes: [
    "openid",        // ID token
    "profile",       // basic profile claims
    "email",         // email claim
    `api://${process.env.REACT_APP_AZURE_BACKEND_API_ID}/access_as_user`, // backend API scope
  ],
};
